module.exports = __webpack_public_path__ + "img/TIME.b6a8d1f9.svg";